import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ParentDetailHomeStore {

}

export enum ParentDetailHomeStoreKeys {

}
